export default "__VITE_PUBLIC_ASSET__d2e622d1__"